var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-cycle */
import React, { useState, useEffect } from 'react';
import Button from '@empiriecom/module-components/Button';
import { ElevationLevel } from '@empiriecom/module-components/Card';
import BasicInput from '@empiriecom/module-components/FormControls/Input/BasicInput';
import Radio from '@empiriecom/module-components/FormControls/Radio';
import Select from '@empiriecom/module-components/FormControls/Select';
import { FormattedMessage, useIntl } from 'react-intl';
import { NotificationProvider, useNotificationContext, } from '@empiriecom/module-components/Notification/NotificationProvider';
import styled, { css } from 'styled-components';
import Panel from '@empiriecom/module-components/Panel';
import RadioGroup from '@empiriecom/module-components/FormControls/RadioGroup';
import { useMedia } from 'react-media-match';
import IntlProvider from './IntlProvider';
import useConfig from '../../hooks/useConfig';
import { StyledContentTop, StyledContentBottom, StyledBackButton, StyledContentBottomSuccess, StyledCard, StyledHeadline, StyledHeadlineForm, StyledSubHeadline, StyledFormRow, StyledFormRadioGroup, StyledMandatory, StyledCheckmark, } from './styles';
import submitForm from './helpers/handleSubmit';
import { createFormSubSelectionsRadio, createFormSubSelectionsSelect, } from './helpers/createFormElements';
import { getFormattedMessage } from './helpers/messages';
import componentConfig from './ComponentConfig';
import { MockDataSuccessPause, MockDataSuccessFrequency, MockDataSuccessUnsubscribe, } from './mockdata';
import InputEmail from '../../FormControls/InputEmail';
var StyleBasic = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin: 0;\n  padding: 0 1rem;\n"], ["\n  width: 100%;\n  margin: 0;\n  padding: 0 1rem;\n"])));
var StyledPanel = styled(Panel)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  padding: 1.25rem 1rem;\n  background-color: ", ";\n"], ["\n  ", "\n  padding: 1.25rem 1rem;\n  background-color: ", ";\n"])), StyleBasic, function (_a) {
    var greyLight = _a.theme.greyLight;
    return greyLight.color.normal;
});
var StyledContentWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), StyleBasic);
var NewsletterUnsubscribe = function (_a) {
    var _b, _c, _d, _e;
    var contentData = _a.contentData, companyId = _a.companyId, forceSuccessType = _a.forceSuccessType;
    var postDataAreaKey = contentData.field_area_key;
    var intl = useIntl();
    var config = useConfig();
    var configForm = componentConfig({ companyId: companyId });
    var isMobile = useMedia({ mobile: true, tablet: false, desktop: false });
    var _f = useState({
        type: 'unsubscribe',
        typeValue: 0,
        emailAddress: '',
        areaKey: '',
    }), statePostData = _f[0], setStatePostData = _f[1];
    var initialFormSubmitResult = function () {
        if (forceSuccessType === 'pause') {
            return MockDataSuccessPause;
        }
        if (forceSuccessType === 'frequency') {
            return MockDataSuccessFrequency;
        }
        if (forceSuccessType === 'unsubscribe') {
            return MockDataSuccessUnsubscribe;
        }
        return null;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _g = useState(null), errorMessage = _g[0], setErrorMessage = _g[1];
    var _h = useState(initialFormSubmitResult), formSubmitResult = _h[0], setFormSubmitResult = _h[1];
    var _j = useState(), stateSelectVal = _j[0], setStateSelectVal = _j[1];
    var _k = useState(false), stateIsFormEmailValid = _k[0], setStateFormEmailValid = _k[1];
    var _l = useState(false), stateFormFilledComplete = _l[0], setStateFormFilledComplete = _l[1];
    var formHasCheckedVal;
    // prevents getting stuck at the last scroll position after the rerender
    useEffect(function () {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [formSubmitResult]);
    var finalizePostData = function () {
        var valEmail = document.getElementById('newsletter-email');
        var finalPostData = __assign(__assign({}, statePostData), {
            emailAddress: valEmail ? valEmail.value : '',
        });
        return finalPostData;
    };
    var preparePostData = function (valInput) {
        var getTypeAndVal = valInput.indexOf('|') !== -1 ? valInput.split('|') : ['unknown', valInput, 'none'];
        var postDataType = getTypeAndVal[0] || '';
        var postDataTypeValuePrepare = getTypeAndVal[1] || 0;
        var postDataTypeValue = Number(postDataTypeValuePrepare);
        var postData = {
            type: postDataType,
            typeValue: postDataTypeValue,
            areaKey: postDataAreaKey || '',
        };
        var finalPostData = __assign(__assign({}, statePostData), postData);
        setStatePostData(finalPostData);
    };
    var checkEmail = function (email) {
        var isEmailValid = config.regExp.eMail.checkProvider.test(email);
        setStateFormEmailValid(isEmailValid);
        return isEmailValid;
    };
    var handleOnEmailChange = function (e) {
        var formEmailInput = e.target;
        var isEmailValid = checkEmail(formEmailInput.value);
        if (formHasCheckedVal && isEmailValid) {
            // preparePostData(formHasCheckedVal);
            setStateFormFilledComplete(true);
        }
    };
    var handleFormCheck = function (event) {
        preparePostData(event.target.value);
        setStateFormFilledComplete(true);
    };
    var formSubmitResultTypePause = formSubmitResult && (formSubmitResult === null || formSubmitResult === void 0 ? void 0 : formSubmitResult.resultType) === 'PAUSE_SUCCESSFUL';
    var formSubmitResultTypeFrequency = formSubmitResult && (formSubmitResult === null || formSubmitResult === void 0 ? void 0 : formSubmitResult.resultType) === 'FREQUENCY_SUCCESSFUL';
    var formSubmitResultTypeUnsubscribe = formSubmitResult && (formSubmitResult === null || formSubmitResult === void 0 ? void 0 : formSubmitResult.resultType) === 'UNSUBSCRIBE_SUCCESSFUL';
    var FormButton = function () {
        var pushNotification = useNotificationContext().pushNotification;
        return (React.createElement(Button, { "data-testid": "unsubscribe-submit", id: "unsubscribe-submit", form: "unsubscribe-form", layout: "primary", size: "large", fullWidth: isMobile, onClick: function (event) {
                event.preventDefault();
                submitForm({ setErrorMessage: setErrorMessage, setFormSubmitResult: setFormSubmitResult, pushNotification: pushNotification }, intl, config, finalizePostData());
            } },
            React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.form.submit", defaultMessage: "" })));
    };
    return (React.createElement(IntlProvider, { companyId: companyId },
        React.createElement(NotificationProvider, null, !formSubmitResult ? (React.createElement(React.Fragment, null,
            React.createElement(StyledContentTop, null,
                React.createElement(StyledHeadline, null,
                    React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.headline" })),
                React.createElement(StyledSubHeadline, null,
                    React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.description" }))),
            React.createElement(StyledPanel, null,
                React.createElement("form", { onSubmit: function (event) {
                        event.preventDefault();
                    }, "data-testid": "newsletter-unsubscribe-form", id: "unsubscribe-form" },
                    React.createElement(StyledCard, { elevationLevel: ElevationLevel['1dp'], showOverflow: true },
                        React.createElement(StyledHeadlineForm, null,
                            React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.form.headline" })),
                        ((_c = (_b = configForm === null || configForm === void 0 ? void 0 : configForm.forms) === null || _b === void 0 ? void 0 : _b.unsubscribeServiceHilfe) === null || _c === void 0 ? void 0 : _c.fields) && ((_e = (_d = configForm === null || configForm === void 0 ? void 0 : configForm.forms) === null || _d === void 0 ? void 0 : _d.unsubscribeServiceHilfe) === null || _e === void 0 ? void 0 : _e.fields.map(function (item) {
                            var hasSubSelections = (item === null || item === void 0 ? void 0 : item.subSelection) || false;
                            // select
                            if (hasSubSelections && item.formType === 'select') {
                                var subSelectionsSelect = createFormSubSelectionsSelect((item === null || item === void 0 ? void 0 : item.subSelection) || [], intl);
                                return (React.createElement(StyledFormRow, null,
                                    React.createElement(Select, { key: "nl-unsub-select", label: getFormattedMessage(item === null || item === void 0 ? void 0 : item.messageKey), "data-type": item.type, onChange: setStateSelectVal, value: stateSelectVal, options: subSelectionsSelect })));
                            }
                            // radio group
                            if (hasSubSelections && item.formType === 'radio') {
                                var subSelectionsRadio = createFormSubSelectionsRadio((item === null || item === void 0 ? void 0 : item.subSelection) || []);
                                if (item === null || item === void 0 ? void 0 : item.checkedValue) {
                                    formHasCheckedVal = item === null || item === void 0 ? void 0 : item.checkedValue;
                                }
                                return (React.createElement(StyledFormRadioGroup, { key: "nl-unsub-radio-group" },
                                    React.createElement(RadioGroup, { "data-type": item.type, label: getFormattedMessage(item === null || item === void 0 ? void 0 : item.messageKey), name: item.type, onChange: handleFormCheck, labelsAndValues: subSelectionsRadio, checkedValue: item === null || item === void 0 ? void 0 : item.checkedValue })));
                            }
                            // single radio
                            if (item.formType === 'radio') {
                                return (React.createElement(StyledFormRow, { key: "nl-unsub-radio" },
                                    React.createElement(Radio, { "data-type": item.type, onChange: handleFormCheck, label: getFormattedMessage(item === null || item === void 0 ? void 0 : item.messageKey), name: item.type })));
                            }
                            if (item.formType === 'email') {
                                return (React.createElement(StyledFormRow, { key: "nl-unsub-email" },
                                    React.createElement(InputEmail, { companyId: companyId, onChange: handleOnEmailChange, name: "emailAdress", id: "newsletter-email" })));
                            }
                            // input
                            return (React.createElement(StyledFormRow, { key: "nl-unsub-input" },
                                React.createElement(BasicInput
                                // @ts-ignore
                                , { 
                                    // @ts-ignore
                                    type: item.formType, "data-type": item.type, placeholder: getFormattedMessage(item === null || item === void 0 ? void 0 : item.messageKey) })));
                        }))))),
            React.createElement(StyledContentWrapper, null,
                React.createElement(StyledContentBottom, null,
                    stateFormFilledComplete && stateIsFormEmailValid ? (React.createElement(FormButton, null)) : (React.createElement(Button, { "data-testid": "unsubscribe-submit-disabled", id: "unsubscribe-submit-disabled", form: "unsubscribe-form", layout: "primary", size: "large", fullWidth: isMobile, disabled: true },
                        React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.form.submit.info", defaultMessage: "" }))),
                    React.createElement(StyledBackButton, null,
                        React.createElement("a", { className: "link-back", href: "/" },
                            React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.back.to.storefront", defaultMessage: "" }))),
                    React.createElement(StyledMandatory, null,
                        React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.form.mandatory", defaultMessage: "" })))))) : (React.createElement(React.Fragment, null,
            React.createElement(StyledContentTop, null,
                React.createElement(StyledCheckmark, { size: "5rem" }),
                React.createElement(StyledHeadline, null,
                    formSubmitResultTypePause && (React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.success.headline.pause" })),
                    formSubmitResultTypeFrequency && (React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.success.headline.frequency" })),
                    formSubmitResultTypeUnsubscribe && (React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.success.headline.unsubscribe" }))),
                React.createElement(StyledSubHeadline, null,
                    formSubmitResultTypePause && (React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.success.description.pause" })),
                    formSubmitResultTypeFrequency && (React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.success.description.frequency" })),
                    formSubmitResultTypeUnsubscribe && (React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.success.description.unsubscribe" })))),
            React.createElement(StyledContentBottomSuccess, null,
                React.createElement(Button, { asLink: true, to: "/", "data-testid": "unsubscribe-submit", id: "unsubscribe-submit", form: "unsubscribe-form", layout: "default", size: "large" },
                    React.createElement(FormattedMessage, { id: "newsletter.unsubscribe.back.to.shop", defaultMessage: "" }))))))));
};
export default NewsletterUnsubscribe;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map